"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center text-foreground">
      <p className="font-script text-7xl leading-none text-primary sm:text-8xl">404</p>
      <h1 className="mt-6 text-2xl font-semibold tracking-tight sm:text-3xl">
        This page took a wrong turn
      </h1>
      <p className="mt-3 max-w-md text-muted-foreground">
        The link may be broken, or the page may have moved. Let&apos;s get you back on track.
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link href="/dashboard">
          <Button className="w-full sm:w-auto">Back to dashboard</Button>
        </Link>
        <Button variant="outline" className="w-full sm:w-auto" onClick={() => window.history.back()}>
          Go back
        </Button>
      </div>
    </div>
  );
}
